import React from "react";
import { Controller } from "react-hook-form";
import {
  AppInputWrapper,
  ErrorLabel,
  InputLabel,
} from "./AppSelectDropdown/AppSelectDropdown.styles";
import "@assets/css/DateTimePicker.css";
interface DateTimePickerProps {
  label: string;
  name: string;
  control: any;
  errors: any;
  disabled?: boolean;
  icon?: React.ReactNode;
  iconRight?: React.ReactNode;
  successStyle?: boolean;
  value?: any;
  maxDate?: Date;
  minDate?: Date;
  onDateChanged?: (date: string) => void;
}

const DateTimePicker: React.FC<DateTimePickerProps> = ({
  label,
  name,
  control,
  errors,
  icon,
  iconRight,
  successStyle,
  onDateChanged,
}) => {
  const onDateChangedHandler = (e: any) => {
    if (onDateChanged) {
      onDateChanged(e.target.value);
    }
  };
  return (
    <div style={{ marginBottom: "1rem", width: "100%", minHeight: 100 }}>
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <AppInputWrapper
        $success={successStyle}
        $leftIcon={!!icon}
        $iconRight={!!iconRight}
      >
        {icon && <span className="input-icon">{icon}</span>}
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <input
              type="datetime-local"
              {...field}
              onChange={onDateChangedHandler}
            />
          )}
        />
      </AppInputWrapper>
      {errors[name] && (
        <ErrorLabel className="error-message">
          {errors[name]?.message}
        </ErrorLabel>
      )}
    </div>
  );
};

export default DateTimePicker;
